import React from "react";
import clsx from "clsx";
import { Paragraph } from "@bloomberg/media-ui-article";

import { RichtextParagraphProps } from "~components/articles/basic/BasicRichtextParagraph";

import styles from "./styles.module.css";

export default function FeatureRichtextParagraph({
    children,
    node,
}: RichtextParagraphProps) {
    return (
        <>
            <Paragraph
                className={clsx({
                    [styles.sectionBreakParagraph]:
                        node.data.class === "section-break",
                })}
            >
                {children}
            </Paragraph>
        </>
    );
}
